/**
 * Context del RelationPanelGroup, separato dal componente per non mischiare
 * export di componente e di hook nello stesso modulo (regola Fast Refresh
 * react-refresh/only-export-components).
 */

import { createContext, useContext } from 'react';

export interface RelationPanelGroupContextValue {
  /** Contatore incrementato a ogni toggle: i panel reagiscono al cambio. */
  signal: number;
  /** Stato target dei panel all'ultimo toggle (true = comprimi tutti). */
  collapsed: boolean;
}

export const RelationPanelGroupContext = createContext<RelationPanelGroupContextValue | null>(null);

/** Hook per i RelationPanel: ritorna null se non sono dentro un gruppo. */
export function useRelationPanelGroup(): RelationPanelGroupContextValue | null {
  return useContext(RelationPanelGroupContext);
}
